import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import { useAttendanceLocalMapStyles } from "./styles";

type AttendanceLocalMapProps = {
  source: string;
};

export default function AttendanceLocalMap({
  source,
}: AttendanceLocalMapProps) {
  const [open, setOpen] = useState(false);
  const { classes } = useAttendanceLocalMapStyles();

  return (
    <>
      <Button
        startIcon={<Visibility fontSize="small" />}
        className={classes.button}
        onClick={() => setOpen(true)}
      >
        Visualizar Mapa
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: { maxHeight: "90vh", width: "30vw", margin: 0 },
        }}
      >
        <Card>
          <CardHeader
            avatar={<Visibility />}
            title={<Typography variant="h5">Mapa</Typography>}
            className={classes.cardHeader}
          />
          <CardContent
            className={classes.cardContent}
            style={{
              maxHeight: "60vh",
              overflowY: "auto",
              minWidth: 0,
              boxSizing: "border-box",
            }}
          >
            <TextField
              fullWidth
              label="Mapa (source)"
              value={source}
              variant="outlined"
              disabled
              inputProps={{
                readOnly: true,
              }}
            />
            <div
              dangerouslySetInnerHTML={{ __html: source }}
              className={classes.cardContentIFrameContainer}
              style={{
                width: "100%",
                maxWidth: "100%",
                overflowX: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            />
          </CardContent>
          <CardActions className={classes.cardActions}>
            <Button className={classes.button} onClick={() => setOpen(false)}>
              Fechar
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </>
  );
}
